import Api from "./api.service";

const ENDPOINT = "cancellation-request";

export default {
  updateCancellationRequest: (lawyerId, data) =>
    Api.patch(`${ENDPOINT}/${lawyerId}`, data),
};
